import Resource from '@/api/Resource';

export default class extends Resource {
  $name = 'labels';

  $defaults() {
    return {
      id: null,
      type: '',
      system: 0,
      name: '',
      description: '',
      color: '',
      icon: '',
    };
  }
}
